//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { article_save, article_update, article_info } from "@/request/api.admin/article";
import ED2 from '../../../components/admin/QuillEditor_1';
import Upload from "../../../components/admin/UploadImage";
export default {
  components: {
    ED2: ED2,
    Upload: Upload
  },
  data: function data() {
    return {
      isAdd: true,
      dialogVisible: false,
      dialogImageUrl: '',
      form: {
        id: '',
        title: "",
        isTop: true,
        briefIntroduction: '',
        source: '',
        indexImg: "",
        content: '',
        author: ''
      },
      rules: {
        title: [{
          required: true,
          message: '请填写文章标题',
          trigger: 'blur'
        }],
        briefIntroduction: [{
          required: true,
          message: '请填写文章简介',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    if (this.$route.query.id) {
      this.isAdd = false;
      this.form['id'] = this.$route.query.id;
      this.getInfo();
    }
  },
  mounted: function mounted() {},
  methods: {
    onImageChange: function onImageChange(value) {
      this.form['indexImg'] = value;
    },
    save: function save() {
      var _this = this;

      this.$refs['form'].validate().then(function (res) {
        article_save(_this.form).then(function (res) {
          console.log('保存', res);

          if (res.code === 0) {
            _this.$message.success('保存成功');

            setTimeout(function () {
              _this.$router.push({
                path: 'article_list'
              });
            }, 1000);
          }
        });
      })["catch"](function (err) {
        _this.$message.warning('请完善信息');
      });
    },
    update: function update() {
      var _this2 = this;

      this.$refs['form'].validate().then(function (res) {
        article_update(_this2.form).then(function (res) {
          console.log('修改', res);

          if (res.code === 0) {
            _this2.$message.success('修改成功');

            setTimeout(function () {
              _this2.$router.push({
                path: 'article_list'
              });
            }, 1000);
          }
        });
      })["catch"](function (err) {
        _this2.$message.warning('请完善信息');
      });
    },
    getInfo: function getInfo() {
      var _this3 = this;

      article_info({
        id: this.form['id']
      }).then(function (res) {
        // console.log(res['article'])
        if (res.code === 0) {
          _this3.$nextTick(function () {
            for (var key in _this3.form) {
              _this3.form[key] = res['article'][key];
            }
          });
        }
      });
    },
    onChange: function onChange(val) {
      // console.log(val)
      this.form['content'] = val;
    }
  }
};